module.exports = __webpack_public_path__ + "static/media/calc.930e6a5d.svg";